import { render, staticRenderFns } from "./GuestIcon.vue?vue&type=template&id=5a28e06e&scoped=true"
import script from "./GuestIcon.vue?vue&type=script&lang=js"
export * from "./GuestIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28e06e",
  null
  
)

export default component.exports